import { MetisClog } from '@yuanfudao/metis-clog-web'
import { INTERCEPT_TYPE } from '@yuanfudao/metis-clog-web/es/types/clog'
import config from './config'

// 创建实例
export const metisClog = new MetisClog({
  // @ts-ignore
  env: process.env.REACT_APP_ENV === 'online' ? 'com' : 'biz',
  // 此参数用来标识来源项目，格式无要求，简洁易读即可
  project: 'metis_login_web',
  // 飞象的 category 为 9，大部分情况无需修改
  category: 9,
})

metisClog.addBeforeInterceptRunCb(INTERCEPT_TYPE.CONSOLE, (clog, data) => {
  if (typeof data.args[0] === 'string' && data.args[0].startsWith('[metis-clog]')) {
    return data
  }
  return null
})


// 初始化，并获取 traceId
export const metisTraceId = metisClog.init({
  // 是否启用
  enabled: process.env.REACT_APP_ENV !== 'development',
  // enabled: true,
  // React render 的元素的ID，ReactDOM.render 的第二个参数
  rootElement: 'root',
  // 需要监控的行为类型，默认全部监控
  interceptTypes: [
    INTERCEPT_TYPE.HTTP,
    INTERCEPT_TYPE.ERROR,
    INTERCEPT_TYPE.HISTORY,
    INTERCEPT_TYPE.CONSOLE,
    INTERCEPT_TYPE.EVENT,
  ],
  // 设置 clog 的header
  headers: {
    // 设置这个参数可更方便地查询，建议这个值和上面c创建实例时的 project 参数一样
    productName: 'metis_login_web',
    productId: config.requestParams._productId
  },
  throttle: { timeout: 500, maxNum: 32 },
})